module.exports = __webpack_public_path__ + "img/logo-icon.2ccb7e7d.svg";